import { IModuleConfiguration, ModuleConfiguration } from 'src/types/system_types';

import safe from'../../../pip/library/pi-safe/pi-safe.js';
import tt from'../../../pip/library/pi-tt/pi-tt.js';

type t_color = string;
type t_uri = string;

declare global {
  interface Window {
    ['HIP']: any;
  }
}

export interface ITenant {
  text_color: t_color;
  color: t_color;
  title: string;
  id: string;
}

export interface IApplication {
  title: string;
  id: string;
}

export interface IProductModuleConfiguration extends IModuleConfiguration {
  uri: {
    application: t_uri;
    tenant: t_uri;
  };
  application: IApplication;
  tenant: ITenant;
}

export class ProductModule extends ModuleConfiguration {
  configuration: IProductModuleConfiguration;

  /**
   *
   * @param configuration
   */
  initialize(configuration: IProductModuleConfiguration) {
    return new Promise((resolve) => {
      this.configuration = this.__defaultConfiguration(configuration);

      resolve(this.configuration);
    });
  }

  activate(configuration: { product: IProductModuleConfiguration }) {
    return Promise.all([this.__pullApplication(configuration.product), this.__pullTenant(configuration.product)]);
  }

  private __defaultConfiguration(configuration: IProductModuleConfiguration) {
    return tt.mergeWith(
      'clobber',
      {
        uri: {
          application: `@platform/application.json`,
          tenant: `@tenants/@tenant.json`
        },
        tenant: {
          text_color: 'var(--hi-color--university-text)',
          color: 'var(--hi-color--university)',
          title: 'None',
          id: 'none'
        },
        application: {
          title: 'None',
          id: 'none'
        }
      },
      configuration
    ) as IProductModuleConfiguration;
  }

  private __pullTenant(productConfiguration: IProductModuleConfiguration) {
    const tenantURI = productConfiguration.uri.tenant;

    return tenantURI == null
      ? Promise.resolve()
      : fetch(safe.uri(tenantURI))
          .then((o) => o.json())
          .then((tenant) => {
            return (this.configuration.tenant = productConfiguration.tenant = tt.mergeWith(
              'clobber',
              productConfiguration.tenant || {},
              tenant || {}
            ));
          })
          .then((tenant) => {
            if (window.HIP) {
              window.HIP.util.setUniversityColor(tenant.color, tenant.text_color);
            }

            return tenant;
          })
          .catch(() => {
            if (window.HIP) {
              window.HIP.util.setUniversityColor(
                productConfiguration.tenant.color,
                productConfiguration.tenant.text_color
              );
            }

            return Promise.resolve();
          });
  }

  private __pullApplication(productConfiguration: IProductModuleConfiguration) {
    const applicationURI = productConfiguration.uri.application;

    return applicationURI == null
      ? Promise.resolve()
      : fetch(safe.uri(applicationURI))
          .then((o) => o.json())
          .then((application) => {
            return (this.configuration.application = productConfiguration.application = tt.mergeWith(
              'clobber',
              productConfiguration.application || {},
              application
            ));
          })
          .catch(() => {
            return Promise.resolve();
          });
  }
}
